import {
  Box,
  Button,
  TextField,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  FormHelperText,
  Tooltip,
  Radio,
  TableCell,
  TableRow,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  DialogActions,
  ListItemText,
  ListItem,
  List,
  Stack,
  Divider,
  Paper,
  FormControlLabel,
  Switch,
  IconButton,
  Checkbox,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useRef, useMemo } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import StorageIcon from "@mui/icons-material/Storage";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { useParams, useNavigate } from "react-router-dom";
import {
  useFetchPrincipalEntitiesdataQuery,
  useGetFilterReportsQuery,
  useGetSearchFilesQuery,
} from "../store/services/principleApi";
import { useGetTemplateByPrincipalIdQuery } from "../store/services/templateApi";
import { useFetchHeadersByPrincipalIdQuery } from "../store/services/headerApi ";
import { useGetCustomerCountriesQuery } from "../store/services/blacklistApi";

import * as XLSX from "xlsx";
import {
  useCreateClickerMutation,
  useGetclickerbyidQuery,
  useGetClickerPreviewMutation,
  useUpdateClickerMutation,
} from "../store/services/clickerApi";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { io } from "socket.io-client";
import socketApi from "../Appjs/socketApi";
import Loader from "../component/common/Loader";
import { layoutCSS } from "../component/common/commonStyle";
import { maskNumber } from "../component/common/Encryption";
import { CheckCircleOutline } from "@mui/icons-material";
import { useCheckMpinStatusQuery } from "../store/services/userApi";
import { useDataEnableServiceQuery } from "../store/services/flowApi";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WifiIcon from "@mui/icons-material/Wifi";
import BatteryFullIcon from "@mui/icons-material/BatteryFull";
import NetworkCellIcon from "@mui/icons-material/NetworkCell";

const MAX_ALLOWED_NUMBERS = 1000000;

// ── Shared sizing tokens (same as BulkSMS) ───────────────────────────────────
const FIELD_HEIGHT = 35;
const FORM_MAX_WIDTH = 510;
const SMALL_FIELD_WIDTH = 220;

// Shows first 3 + "..." + last 3 characters
const trimPeId = (id) => {
  const str = String(id ?? "");
  if (str.length <= 6) return str;
  return `${str.slice(0, 3)}...${str.slice(-3)}`;
};

// Tighter dropdown options (same as BulkSMS)
const compactMenuProps = {
  PaperProps: {
    sx: {
      "& .MuiMenuItem-root": {
        minHeight: 28,
        py: 0.25,
        px: 1.5,
        fontSize: "0.8rem",
      },
    },
  },
  MenuListProps: { dense: true, sx: { py: 0.5 } },
};

// Glass look used by Select / input roots (same as BulkSMS)
const glassField = {
  height: FIELD_HEIGHT,
  minHeight: FIELD_HEIGHT,
  maxHeight: FIELD_HEIGHT,
  fontSize: "0.8rem",
  background: "rgba(255,255,255,0.7)",
  backdropFilter: "blur(8px)",
  borderRadius: "8px",
  "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.05)" },
};

// TextField flavor of the glass look
const glassInputSx = {
  "& .MuiOutlinedInput-root": { ...glassField },
  "& .MuiInputLabel-root": { fontSize: "0.8rem" },
  "& .MuiInputBase-input": { fontSize: "0.8rem" },
  "& .MuiFormHelperText-root": { fontSize: "0.68rem" },
};

// Outlined glass buttons (Upload / ChooseDB)
const glassBtnSx = {
  flex: 1,
  minWidth: 0,
  height: FIELD_HEIGHT,
  px: 1,
  textTransform: "none",
  fontSize: "0.75rem",
  whiteSpace: "nowrap",
  background: "rgba(255,255,255,0.7)",
  backdropFilter: "blur(8px)",
  borderRadius: "8px",
  "& .MuiButton-startIcon": { mr: 0.5 },
  "&:hover": {
    background: "rgba(255,255,255,0.9)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  },
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

// Blinking dots shown in the phone when message is empty
const TypingIndicator = () => (
  <Box sx={{ display: "flex", gap: 0.5 }}>
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: "#94A3B8",
          animation: "blink 1.4s infinite",
          animationDelay: `${i * 0.2}s`,
          "@keyframes blink": {
            "0%,100%": { opacity: 0.3 },
            "50%": { opacity: 1 },
          },
        }}
      />
    ))}
  </Box>
);

const CreateCampaign = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  // States
  const { data: dbFiles, isLoading: dbFilesLoading } = useGetSearchFilesQuery();
  const [previewCkicker, { data }] = useGetClickerPreviewMutation();
  console.log("preview data", data);

  const [socket, setSocket] = useState(null);
  const [reviewData, setReviewData] = useState(null);
  const [totalnumbers, settotalnumbers] = useState(0);
  const [totalremains, setTotalRemains] = useState(0);
  const [message, setMessage] = useState("");
  const [entityId, setEntityId] = useState(null);
  const [senderId, setSenderId] = useState("");
  const [isPreviewopen, setIsPreviewopen] = useState(false);
  const [outfilepath, setOutFilePath] = useState("");
  const [originalFileNames, setOriginalFileNames] = useState("");
  const [scheduleDate, setScheduleDate] = useState(
    dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  );
  const [fileSource, setFileSource] = useState("");
  const [enableFilterTill, setEnableFilterTill] = React.useState(false);
  const { data: checkmpin, refetch: refetchmpin } = useCheckMpinStatusQuery();
  const [enableSchedule, setEnableSchedule] = useState(false);
  const { data: filterReports, isLoading: filterLoading } =
    useGetFilterReportsQuery();
  const [minDateTime, setMinDateTime] = useState(
    dayjs().format("YYYY-MM-DDTHH:mm"),
  );
  const { data: dataEnableRes } = useDataEnableServiceQuery();

  // Phone preview clock
  const [currentTime, setCurrentTime] = useState("");

  // Split scheduler states
  const [enableSplit, setEnableSplit] = useState(false);
  const [batchSize, setBatchSize] = useState("");
  const [timeInterval, setTimeInterval] = useState("");

  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [fileNames, setFileNames] = useState("");
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [templateSearch, setTemplateSearch] = useState("");
  const [filterDatatill_days, setFilterDatatill_days] = useState(0);
  const [file, setFile] = useState(null);
  const [campaignname, setCampaignName] = useState("");
  const [landingPage, setLandingPage] = useState("");

  const [templateId, setTemplateId] = useState("");
  const [prId, setPrId] = useState(null);
  const [principalEntities, setPrincipalEntities] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [isCountryModalOpen, setIsCountryModalOpen] = useState(false);
  const fileInputRef = useRef(null);
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [selectedDbFile, setSelectedDbFile] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState({
    id: 1,
    name: "India",
    code: "+91",
  });

  // Transliteration states
  const [isTransliterationEnabled, setIsTransliterationEnabled] =
    useState(false);
  const [transliterationControl, setTransliterationControl] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState("hi");

  const [textEditorMode, setTextEditorMode] = useState("eng");

  // Mutations
  const [createClicker, { isLoading: bulkIsLoading }] =
    useCreateClickerMutation();
  const [updateClicker] = useUpdateClickerMutation();

  // API Calls
  const {
    data: templatesData,
    isLoading: templatesLoading,
    isError: templatesError,
  } = useGetTemplateByPrincipalIdQuery(prId, {
    skip: !prId,
  });
  const {
    data: principalEntitiesData,
    isLoading: isLoadingEntities,
    isError: isEntitiesError,
  } = useFetchPrincipalEntitiesdataQuery();

  const { data: headersData } = useFetchHeadersByPrincipalIdQuery(prId, {
    skip: !prId,
  });
  const { data: countriesData } = useGetCustomerCountriesQuery();

  const { data: campaignData, isLoading: isLoadingCampaign } =
    useGetclickerbyidQuery(id, {
      skip: !isEdit,
    });

  // Phone clock tick
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      setCurrentTime(`${hours}:${minutes}`);
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (campaignData?.data && isEdit) {
      const c = campaignData.data;

      setCampaignName(c.campaignname || "");
      setMessage(c.smstext || "");
      setLandingPage(c.landing_page || "");
      setScheduleDate(
        c.time_to_send
          ? dayjs(c.time_to_send).format("YYYY-MM-DD HH:mm:ss")
          : dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      );
      setTemplateId(c.template_id || "");
      setSenderId(c.header_name || "");
      setEntityId({ pe_id: c.pe_id, principalentity_id: c.principalentity_id });
      setPrId(c.principalentity_id || null);
      if (c.country_id && c.country_code) {
        setSelectedCountry({
          id: c.country_id,
          name: c.country_name || "Unknown",
          code: c.country_code,
        });
      }
      if (c.enable_split) {
        setEnableSplit(true);
        setBatchSize(c.batch_size || "");
        setTimeInterval(c.time_interval || "");
      }
    }
  }, [campaignData, isEdit]);

  useEffect(() => {
    if (principalEntitiesData) {
      setPrincipalEntities(principalEntitiesData.data || []);
    }
  }, [principalEntitiesData]);

  useEffect(() => {
    if (data?.file.originalName) {
      setOriginalFileNames(data.file.originalName);
    }
    if (data?.results?.totalposted) {
      settotalnumbers(data.results.totalposted);
    }
    if (data?.results?.outfilepath) {
      setOutFilePath(data.results.outfilepath);
    }
    if (data?.results?.totalremains) {
      setTotalRemains(data.results.totalremains);
    }
  }, [data]);

  useEffect(() => {
    if (templatesData) {
      setTemplates(templatesData.data || []);
    }
  }, [templatesData]);

  const filteredTemplates = templates.filter((template) =>
    (template.template_name || "")
      .toLowerCase()
      .includes(templateSearch.trim().toLowerCase()),
  );

  useEffect(() => {
    if (headersData) {
      setHeaders(headersData.data || []);
    }
  }, [headersData]);

  const getHeaderName = (headerId) => {
    if (!headerId) return "";
    const header = headers.find(
      (h) => String(h.header_id) === String(headerId),
    );
    return header?.header_name || "";
  };

  useEffect(() => {
    const newSocket = io(socketApi, {
      transports: ["websocket"],
      secure: true,
    });
    setSocket(newSocket);

    newSocket.on("connect", () => console.log("Connected to Socket.IO server"));
    newSocket.on("disconnect", () =>
      console.log("Disconnected from Socket.IO server"),
    );

    return () => newSocket.disconnect();
  }, []);

  useEffect(() => {
    const loadTransliterationAPI = () => {
      google.load("elements", "1", {
        packages: "transliteration",
        callback: onLoad,
      });
    };

    const script = document.createElement("script");
    script.src = "https://www.google.com/jsapi";
    script.onload = loadTransliterationAPI;
    document.body.appendChild(script);
  }, []);

  const onLoad = () => {
    const txtMessageElement = document.getElementById("txtMessage");
    if (!txtMessageElement) {
      console.warn("txtMessage element not found, retrying in 100ms");
      setTimeout(onLoad, 100);
      return;
    }
    const options = {
      sourceLanguage: "en",
      destinationLanguage: [
        "hi",
        "ar",
        "bn",
        "fa",
        "gu",
        "kn",
        "ml",
        "mr",
        "ne",
        "pa",
        "ta",
        "te",
        "ur",
      ],
      transliterationEnabled: false,
      shortcutKey: "ctrl+g",
    };

    const control = new google.elements.transliteration.TransliterationControl(
      options,
    );
    setTransliterationControl(control);

    const ids = ["txtMessage"];
    control.makeTransliteratable(ids);

    setIsTransliterationEnabled(control.isTransliterationEnabled());

    const supportedLanguages =
      google.elements.transliteration.getDestinationLanguages(
        google.elements.transliteration.LanguageCode.ENGLISH,
      );
    setLanguages(supportedLanguages);

    control.addEventListener(
      google.elements.transliteration.TransliterationControl.EventType
        .STATE_CHANGED,
      transliterateStateChangeHandler,
    );
  };

  const transliterateStateChangeHandler = (e) => {
    setIsTransliterationEnabled(e.transliterationEnabled);
  };

  const handleBatchSizeChange = (e) => {
    const value = e.target.value;
    setBatchSize(value);
    setErrors((prev) => ({
      ...prev,
      batchSize:
        value && Number(value) < 1000 ? "Minimum batch size is 1000" : undefined,
    }));
  };

  const handleTimeIntervalChange = (e) => {
    const value = e.target.value;
    setTimeInterval(value);
    setErrors((prev) => ({
      ...prev,
      timeInterval:
        value && Number(value) < 10 ? "Minimum interval is 10 minutes" : undefined,
    }));
  };

  const handlepreviewSubmit = async () => {
    const formData = new FormData();

    formData.append("noofdays", filterDatatill_days);
    formData.append("customer_id", 1);
    formData.append("country_code", selectedCountry.code?.trim());
    formData.append("smsCount", smsCount || 0);
    formData.append("country_id", selectedCountry.id || "");
    formData.append("service_id", 1);
    formData.append("smstext", message?.trim());
    formData.append("language", textEditorMode || "eng");

    if (fileSource) {
      formData.append("file_source", fileSource);
    }

    if (selectedDbFile) {
      formData.append("FirstApiPath", selectedDbFile.path);
    } else if (file) {
      formData.append("file", file);
    }

    if (enableSplit) {
      formData.append("enable_split", "true");
      formData.append("batch_size", batchSize);
      formData.append("time_interval", timeInterval);
    }

    try {
      await previewCkicker(formData).unwrap();
      console.log("Data uploaded successfully");
    } catch (error) {
      const errorMessage =
        error?.data?.error || error?.message || "Error uploading file";
      toast.error(errorMessage);
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) {
      setFile(null);
      setSelectedDbFile(null);
      setFileNames("");
      setFileSource("");
      return;
    }
    const selectedFile = files[0];
    setSelectedDbFile(null);
    setFileSource("uploadFile");
    if (!selectedFile) return;

    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
    const allowedExtensions = ["csv", "txt", "xlsx"];

    if (!allowedExtensions.includes(fileExtension)) {
      setError("Only .csv, .txt, and .xlsx files are allowed.");
      setFile(null);
      setSelectedDbFile(null);
      setFileNames("");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      let content = e.target.result;

      if (fileExtension === "xlsx") {
        try {
          const workbook = XLSX.read(content, { type: "binary" });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          content = XLSX.utils.sheet_to_csv(firstSheet);
        } catch (err) {
          setError("Failed to read XLSX file.");
          setFile(null);
          setSelectedDbFile(null);
          setFileNames("");
          event.target.value = "";
          return;
        }
      }

      const numberArray = content
        .split(/[\n,\s]+/)
        .map((n) => n.trim())
        .filter((n) => /^\d{10,}$/.test(n));

      if (numberArray.length > MAX_ALLOWED_NUMBERS) {
        setError("File contains more than 10 lakh numbers.");
        setFile(null);
        setSelectedDbFile(null);
        setFileNames("");
        event.target.value = "";
        return;
      }

      setSelectedDbFile(null);
      setFile(selectedFile);
      setFileNames(`${selectedFile.name} `);
      setError("");
    };

    if (fileExtension === "xlsx") {
      reader.readAsBinaryString(selectedFile);
    } else {
      reader.readAsText(selectedFile);
    }
  };

  const handleEntityChange = (e) => {
    const selectedEntity = e.target.value;
    setEntityId(selectedEntity);
    setPrId(selectedEntity?.principalentity_id || null);
    setSenderId("");
    setTemplateId("");
    setMessage("");
    setHeaders([]);
    setTemplates([]);
    setErrors({ ...errors, entityId: false, senderId: false });
  };

  const handleTemplateSelect = (template) => {
    if (!template) return;

    setTemplateId(template.trai_template_id);
    setMessage(template.template_text || "");
    setSenderId(getHeaderName(template.header_id));

    setErrors({ ...errors, message: false, senderId: false });
    setIsTemplateModalOpen(false);
    setTemplateSearch("");
  };

  const handleCountryModalToggle = () =>
    setIsCountryModalOpen(!isCountryModalOpen);

  const handleCountrySelect = (countryId, countryName, countrycode) => {
    setSelectedCountry({
      id: countryId,
      name: countryName,
      code: countrycode.trim(),
    });
  };

  const checkboxClickHandler = () => {
    if (transliterationControl) {
      transliterationControl.toggleTransliteration();
      const isEnabled = transliterationControl.isTransliterationEnabled();
      setIsTransliterationEnabled(isEnabled);
      if (isEnabled) {
        setCurrentLanguage("hi");
        transliterationControl.setLanguagePair(
          google.elements.transliteration.LanguageCode.ENGLISH,
          "hi",
        );
      }
    }
  };

  const languageChangeHandler = (event) => {
    const selectedLang = event.target.value;
    setCurrentLanguage(selectedLang);
    if (transliterationControl) {
      transliterationControl.setLanguagePair(
        google.elements.transliteration.LanguageCode.ENGLISH,
        selectedLang,
      );
    }
  };

  const validateForm = () => {
    const newErrors = {
      campaignname: !campaignname,
      entityId: !entityId,
      senderId: !senderId,
      message: !message,
    };

    if (enableSplit) {
      if (!batchSize || Number(batchSize) < 1000) {
        newErrors.batchSize = "Minimum batch size is 1000";
        toast.error("Minimum batch size is 1000");
      }
      if (!timeInterval || Number(timeInterval) < 10) {
        newErrors.timeInterval = "Minimum interval is 10 minutes";
        toast.error("Minimum time interval is 10 minutes");
      }
    }

    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const handleReviewClick = async () => {
    if (!entityId) {
      toast.error("Please select a PRINCIPAL ENTITY.");
      return;
    }

    if (!senderId) {
      toast.error("Please select a template to get header name");
      return;
    }

    try {
      const data = {
        entity: entityId?.pe_name
          ? `${entityId.pe_name} (${entityId.pe_id ? trimPeId(entityId.pe_id) : ""})`
          : "Not selected",
        senderId: senderId || "Not selected",
        campaignname: campaignname || "No name",
        message: message || "No message",
        templateId: templateId ? maskNumber(templateId) : "None",
        country: `${selectedCountry.name} (${selectedCountry.code})`,

        schedule: scheduleDate
          ? dayjs(scheduleDate).format("YYYY-MM-DD HH:mm:ss")
          : "Immediate",
        file: selectedDbFile
          ? `From DB: ${selectedDbFile.path}`
          : file
            ? file.name
            : "No file uploaded",

        charCount: charCount,
        smsCount: smsCount,
        landingPage: landingPage || "None",
        filterDatatill_days: filterDatatill_days || 0,
        splitScheduler: enableSplit
          ? `Enabled - Batch: ${batchSize}, Interval: ${timeInterval} min`
          : "Disabled",
      };

      setReviewData(data);
      console.log("Review Data:", data);
      setIsPreviewopen(true);
    } catch (error) {
      console.error("Error checking spam keywords:", error);
      toast.error("Failed to check for spam keywords. Please try again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!senderId) {
      toast.error("Please select a template to get header name");
      setErrors((prev) => ({ ...prev, senderId: true }));
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill all required fields");
      return;
    }

    if (!fileSource) {
      toast.error("Please upload a file or select from database");
      return;
    }

    const payload = {
      campaignname: campaignname?.trim(),
      pe_id: entityId?.pe_id?.toString(),
      header_name: senderId?.trim(),
      smstext: message?.trim(),
      time_to_send: dayjs(scheduleDate).format("YYYY-MM-DD HH:mm:ss"),
      template_id: templateId?.toString(),
      country_id: selectedCountry.id?.toString(),
      country_code: selectedCountry.code?.trim(),
      landing_page: landingPage?.trim(),
      upload_file_path: outfilepath,
      smsCount,
      filter_days: filterDatatill_days,
      charCount,
      total_numbers: totalnumbers,
      totalremains: totalremains,
      originalFileName: originalFileNames,
      language: textEditorMode,
      file_source: fileSource,
      enable_split: enableSplit,
      batch_size: enableSplit ? Number(batchSize) || 0 : 0,
      time_interval: enableSplit ? Number(timeInterval) || 0 : 0,
    };

    try {
      let response;
      if (isEdit) {
        response = await updateClicker({ id, body: payload }).unwrap();
        toast.success("Campaign updated successfully");
      } else {
        response = await createClicker(payload).unwrap();
        toast.success("Campaign created successfully");
      }

      if (socket && response?.clicker_id) {
        socket.emit("clicker-sms", { clicker_id: response.clicker_id });
      }
      navigate("/ManageCampaign");
    } catch (error) {
      console.error(error);
      toast.error(error?.data?.message || "Something went wrong");
    }
  };

  const charCount = message?.length || 0;
  const smsCount = Math.ceil(charCount / 160) || 0;

  if (bulkIsLoading || isLoadingCampaign) {
    return <Loader />;
  }

  return (
    <div>
      {/* ── Page header ─────────────────────────────────────────────────── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 1.5,
          m: 1,
          background: "rgba(255,255,255,0.5)",
          backdropFilter: "blur(8px)",
          borderRadius: "12px",
          border: "1px solid #E2E8F0",
        }}
      >
        <IconButton
          onClick={() => window.history.back()}
          size="small"
          sx={{ mr: 1 }}
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Create Campaign
        </Typography>
      </Box>

      {/* ── Form ────────────────────────────────────────────────────────── */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mx: 1,
          mt: 1,
          p: 2,
          borderRadius: 2,
          background: "rgba(255,255,255,0.35)",
          backdropFilter: "blur(8px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 4,
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          {/* ════════ LEFT: form ════════ */}
          <Box sx={{ flex: "1 1 480px", maxWidth: FORM_MAX_WIDTH, minWidth: 0 }}>
            {/* SMS Language */}
            <Box sx={{ mt: 0.5 }}>
              <FormControl size="small" sx={{ minWidth: 100 }}>
                <InputLabel
                  id="text-editor-mode-label"
                  sx={{ fontSize: "0.8rem" }}
                >
                  SMS Language
                </InputLabel>
                <Select
                  labelId="text-editor-mode-label"
                  id="text-editor-mode-select"
                  value={textEditorMode}
                  label="SMS Language"
                  MenuProps={compactMenuProps}
                  onChange={(e) => {
                    setTextEditorMode(e.target.value);
                    if (
                      e.target.value === "eng" &&
                      isTransliterationEnabled &&
                      transliterationControl
                    ) {
                      transliterationControl.toggleTransliteration();
                      setIsTransliterationEnabled(false);
                    }
                  }}
                  sx={{
                    ...glassField,
                    "& .MuiSelect-select": { fontSize: "0.8rem" },
                  }}
                >
                  <MenuItem value="eng" sx={{ fontSize: "0.8rem" }}>
                    English Lang
                  </MenuItem>
                  <MenuItem value="other" sx={{ fontSize: "0.8rem" }}>
                    Other Lang
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Top row */}
            <Box
              sx={{
                display: "flex",
                mt: 1.5,
                gap: 2,
                alignItems: "flex-start",
              }}
            >
              {/* Left column */}
              <Stack
                spacing={1}
                sx={{ flexShrink: 0, alignItems: "flex-start" }}
              >
                <TextField
                  label="Campaign Name"
                  required
                  size="small"
                  sx={{ width: SMALL_FIELD_WIDTH, ...glassInputSx }}
                  value={campaignname}
                  onChange={(e) => {
                    setCampaignName(e.target.value);
                    setErrors({ ...errors, campaignname: false });
                  }}
                  error={errors.campaignname}
                  helperText={
                    errors.campaignname && "Campaign name is required"
                  }
                />

                <FormControl
                  size="small"
                  sx={{ width: SMALL_FIELD_WIDTH }}
                  error={errors.entityId}
                >
                  <InputLabel id="entity-label" sx={{ fontSize: "0.8rem" }}>
                    Entity Id
                  </InputLabel>
                  <Select
                    labelId="entity-label"
                    id="entityId-select"
                    label="Entity Id"
                    value={entityId || ""}
                    onChange={handleEntityChange}
                    MenuProps={compactMenuProps}
                    sx={glassField}
                    renderValue={(val) => {
                      if (!val?.pe_id) return "Select Entity";
                      return (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            minWidth: 0,
                            fontSize: "0.8rem",
                          }}
                        >
                          {val.pe_name && (
                            <Box
                              sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                minWidth: 0,
                              }}
                            >
                              {val.pe_name}
                            </Box>
                          )}
                          <Box sx={{ flexShrink: 0, whiteSpace: "nowrap" }}>
                            ({trimPeId(val.pe_id)})
                          </Box>
                        </Box>
                      );
                    }}
                  >
                    <MenuItem value="" sx={{ fontSize: "0.8rem" }}>
                      Select Entity
                    </MenuItem>
                    {isLoadingEntities ? (
                      <MenuItem disabled sx={{ fontSize: "0.8rem" }}>
                        Loading entities...
                      </MenuItem>
                    ) : isEntitiesError ? (
                      <MenuItem disabled sx={{ fontSize: "0.8rem" }}>
                        Error loading entities
                      </MenuItem>
                    ) : principalEntities?.length > 0 ? (
                      principalEntities.map((entity) => (
                        <MenuItem
                          key={entity.pe_id}
                          value={entity}
                          sx={{ fontSize: "0.8rem" }}
                        >
                          {entity.pe_name} ({trimPeId(entity.pe_id)})
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled sx={{ fontSize: "0.8rem" }}>
                        No entities available
                      </MenuItem>
                    )}
                  </Select>
                  {errors.entityId && (
                    <FormHelperText>Entity ID is required</FormHelperText>
                  )}
                </FormControl>

                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ width: SMALL_FIELD_WIDTH, alignItems: "center" }}
                >
                  {dataEnableRes?.isdataenable !== null && (
                    <Button
                      variant="outlined"
                      startIcon={<StorageIcon />}
                      onClick={() => setIsFileModalOpen(true)}
                      sx={glassBtnSx}
                    >
                      <Tooltip
                        title={selectedDbFile ? selectedDbFile.filter_name : ""}
                        arrow
                      >
                        <Box
                          component="span"
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "block",
                          }}
                        >
                          {selectedDbFile
                            ? selectedDbFile.filter_name
                            : "ChooseDB"}
                        </Box>
                      </Tooltip>
                    </Button>
                  )}

                  <Button
                    component="label"
                    role={undefined}
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                    sx={glassBtnSx}
                  >
                    <Tooltip title={file ? file.name : ""} arrow>
                      <Box
                        component="span"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "block",
                        }}
                      >
                        {file
                          ? file.name.length > 12
                            ? file.name.substring(0, 12) + "..."
                            : file.name
                          : "UploadFile"}
                      </Box>
                    </Tooltip>
                    <VisuallyHiddenInput
                      type="file"
                      id="fileUpload"
                      accept=".csv,.txt,.xlsx"
                      onChange={handleFileChange}
                      ref={fileInputRef}
                    />
                  </Button>
                </Stack>

                {error && (
                  <Typography
                    variant="body2"
                    color="error"
                    sx={{ fontSize: "0.7rem" }}
                  >
                    {error}
                  </Typography>
                )}

                {/* Filter From LC */}
                {checkmpin?.data?.allow7_day_filter && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          size="small"
                          checked={enableFilterTill}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setEnableFilterTill(checked);
                            if (!checked) setFilterDatatill_days(0);
                          }}
                        />
                      }
                      label="Filter From LC"
                      sx={{
                        m: 0,
                        "& .MuiFormControlLabel-label": {
                          fontSize: "0.75rem",
                          color: "#000",
                        },
                      }}
                    />
                    {enableFilterTill && (
                      <FormControl size="small" sx={{ width: 130 }}>
                        <InputLabel sx={{ fontSize: "0.7rem" }}>
                          Filter Till
                        </InputLabel>
                        <Select
                          value={filterDatatill_days}
                          label="Filter Till"
                          onChange={(e) =>
                            setFilterDatatill_days(e.target.value)
                          }
                          MenuProps={compactMenuProps}
                          sx={{ ...glassField, fontSize: "0.75rem" }}
                        >
                          <MenuItem value={1} sx={{ fontSize: "0.75rem" }}>
                            Today
                          </MenuItem>
                          <MenuItem value={2} sx={{ fontSize: "0.75rem" }}>
                            Yesterday
                          </MenuItem>
                          {Array.from({ length: 28 }, (_, i) => {
                            const day = i + 3;
                            return (
                              <MenuItem
                                key={day}
                                value={day}
                                sx={{ fontSize: "0.75rem" }}
                              >
                                Last {day} days
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}
                  </Box>
                )}

                {/* Landing Page */}
                <TextField
                  label="Landing Page"
                  size="small"
                  sx={{ width: SMALL_FIELD_WIDTH, ...glassInputSx }}
                  value={landingPage}
                  onChange={(e) => setLandingPage(e.target.value)}
                />
              </Stack>

              {/* Right column: Split Scheduler */}
              <Stack spacing={1} sx={{ flex: 1, minWidth: 0 }}>
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={enableSplit}
                      onChange={(e) => {
                        setEnableSplit(e.target.checked);
                        if (!e.target.checked) {
                          setErrors((prev) => ({
                            ...prev,
                            batchSize: undefined,
                            timeInterval: undefined,
                          }));
                        }
                      }}
                    />
                  }
                  label="Enable Split Scheduler"
                  sx={{
                    m: 0,
                    "& .MuiFormControlLabel-label": {
                      fontSize: "0.75rem",
                      color: "#000",
                    },
                  }}
                />
                {enableSplit && (
                  <Stack spacing={1}>
                    <TextField
                      label="Batch Size"
                      type="number"
                      size="small"
                      fullWidth
                      value={batchSize}
                      onChange={handleBatchSizeChange}
                      error={!!errors.batchSize}
                      helperText={errors.batchSize || "Min 1000"}
                      inputProps={{ min: 1000 }}
                      sx={glassInputSx}
                    />
                    <TextField
                      label="Interval (minutes)"
                      type="number"
                      size="small"
                      fullWidth
                      value={timeInterval}
                      onChange={handleTimeIntervalChange}
                      error={!!errors.timeInterval}
                      helperText={errors.timeInterval || "Min 10 min"}
                      inputProps={{ min: 10 }}
                      sx={glassInputSx}
                    />
                  </Stack>
                )}
              </Stack>
            </Box>

            {/* Message Area */}
            <Box>
              {textEditorMode === "other" && (
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isTransliterationEnabled}
                        onChange={checkboxClickHandler}
                        size="small"
                      />
                    }
                    label="Enable Text Editor:"
                    componentsProps={{ typography: { fontSize: "0.75rem" } }}
                  />
                  {isTransliterationEnabled && (
                    <Select
                      onChange={languageChangeHandler}
                      disabled={!isTransliterationEnabled}
                      size="small"
                      value={currentLanguage}
                      MenuProps={compactMenuProps}
                      sx={{
                        minWidth: 30,
                        fontSize: "0.7rem",
                        background: "rgba(255,255,255,0.7)",
                        borderRadius: "6px",
                      }}
                    >
                      {Object.entries(languages).map(([key, value]) => (
                        <MenuItem
                          key={value}
                          value={value}
                          sx={{ fontSize: "0.7rem" }}
                        >
                          {key}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                </Box>
              )}

              <TextField
                label="Message"
                id="txtMessage"
                required
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value);
                  setErrors({ ...errors, message: false });
                }}
                multiline
                rows={3}
                variant="outlined"
                margin="normal"
                error={errors.message}
                sx={{
                  width: "100%",
                  maxWidth: FORM_MAX_WIDTH,
                  "& .MuiInputLabel-root": { fontSize: "0.8rem" },
                  "& .MuiOutlinedInput-root": {
                    fontSize: "0.8rem",
                    background: "rgba(255,255,255,0.7)",
                    backdropFilter: "blur(8px)",
                  },
                }}
                helperText={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mt: 0.5,
                    }}
                  >
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() => setIsTemplateModalOpen(true)}
                      disabled={!entityId}
                      sx={{
                        textTransform: "none",
                        fontSize: "0.7rem",
                        px: 1,
                        py: 0.5,
                      }}
                    >
                      Open Template
                    </Button>
                    <Box sx={{ fontSize: "0.7rem", color: "text.secondary" }}>
                      SMS Count: {smsCount} | Char Count: {charCount}
                    </Box>
                  </Box>
                }
                FormHelperTextProps={{ sx: { margin: 0 } }}
              />
              <Typography
                variant="caption"
                sx={{ display: "block", color: "red", fontSize: "0.7rem" }}
              >
                Counts may vary depending on the variable length of the uploaded
                file.
              </Typography>
              {errors.message && (
                <FormHelperText error sx={{ mt: 0.5 }}>
                  Message is required
                </FormHelperText>
              )}
              {errors.senderId && (
                <FormHelperText error sx={{ mt: 0.5 }}>
                  Select a template to set the sender ID
                </FormHelperText>
              )}
            </Box>

            {/* Schedule */}
            <Box display="flex" alignItems="center" gap={2} mt={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={enableSchedule}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setEnableSchedule(checked);

                        if (!checked) {
                          const now = dayjs().format("YYYY-MM-DDTHH:mm");
                          setScheduleDate(now);
                        } else {
                          setMinDateTime(dayjs().format("YYYY-MM-DDTHH:mm"));
                        }
                      }}
                      size="small"
                    />
                  }
                  label="Schedule For Later?"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "0.8rem",
                      color: "#000",
                    },
                  }}
                />
                {enableSchedule && (
                  <TextField
                    label="Schedule Date"
                    type="datetime-local"
                    value={scheduleDate}
                    onChange={(e) => {
                      const selectedDateTime = e.target.value;
                      const now = dayjs().format("YYYY-MM-DDTHH:mm");

                      if (dayjs(selectedDateTime).isBefore(now)) {
                        toast.error("Schedule time cannot be in the past");
                        setScheduleDate(now);
                      } else {
                        setScheduleDate(selectedDateTime);
                      }
                    }}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ min: minDateTime }}
                    sx={{
                      width: 200,
                      "& .MuiInputBase-root": {
                        fontSize: "0.8rem",
                        background: "rgba(255,255,255,0.7)",
                      },
                      "& .MuiInputLabel-root": { fontSize: "0.8rem" },
                    }}
                  />
                )}
              </Box>
            </Box>

            {/* Country & Preview */}
            <Box display="flex" alignItems="center" gap={2} mt={2}>
              <div className="flex items-center text-[0.8rem]">
                <label className="block font-medium text-[0.8rem]">
                  Select Country
                </label>
                <div className="py-2 ms-3">
                  {selectedCountry ? (
                    <span
                      className="text-blue-500 cursor-pointer underline"
                      onClick={handleCountryModalToggle}
                    >
                      {selectedCountry.name} ({selectedCountry.code})
                    </span>
                  ) : (
                    <button
                      type="button"
                      onClick={handleCountryModalToggle}
                      className="text-blue-500 underline"
                    >
                      Select Country
                    </button>
                  )}
                </div>
              </div>

              <Button
                variant="outlined"
                color="primary"
                size="medium"
                onClick={() => {
                  handleReviewClick();
                  handlepreviewSubmit();
                }}
                sx={{ textTransform: "none", fontSize: "0.8rem", px: 2 }}
              >
                Preview
              </Button>
            </Box>
          </Box>

          {/* ════════ RIGHT: phone preview (message only, no buttons) ════════ */}
          <Box sx={{ flex: "0 0 auto", mx: "auto" }}>
            <Paper
              sx={{
                width: "260px",
                height: "480px",
                mx: "auto",
                borderRadius: "28px",
                background: "#0F172A",
                padding: "6px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                border: "1px solid #E2E8F0",
                position: "relative",
                transition: "all 0.25s ease",
                "&:hover": { transform: "scale(1.015)" },
              }}
            >
              {/* Inner Screen */}
              <Box
                sx={{
                  background: "#FFFFFF",
                  borderRadius: "22px",
                  overflow: "hidden",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Status Bar */}
                <Box
                  sx={{
                    width: "100%",
                    height: "30px",
                    px: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    background: "#111827",
                    color: "#E5E7EB",
                  }}
                >
                  <Typography fontSize="0.7rem" opacity={0.8}>
                    {currentTime}
                  </Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <WifiIcon sx={{ fontSize: "14px", opacity: 0.8 }} />
                    <NetworkCellIcon sx={{ fontSize: "14px", opacity: 0.8 }} />
                    <BatteryFullIcon sx={{ fontSize: "14px", opacity: 0.8 }} />
                  </Stack>
                </Box>

                {/* Sender Header */}
                <Box
                  sx={{
                    width: "100%",
                    height: "50px",
                    px: 2,
                    display: "flex",
                    alignItems: "center",
                    borderBottom: "1px solid #E2E8F0",
                    background: "#F1F5F9",
                    color: "#0F172A",
                    fontWeight: 600,
                    flexShrink: 0,
                  }}
                >
                  <ArrowBackIcon fontSize="small" />
                  <Typography
                    sx={{ ml: 1, fontWeight: "bold", fontSize: "0.85rem" }}
                  >
                    {`FM-${senderId?.trim() || "SENDER ID"}`}
                  </Typography>
                </Box>

                {/* Message Area */}
                <Box
                  sx={{
                    flex: 1,
                    p: 1,
                    overflowY: "auto",
                    "&::-webkit-scrollbar": { width: "4px" },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#CBD5F5",
                      borderRadius: "10px",
                    },
                  }}
                >
                  {/* Message bubble — only template text, no buttons */}
                  <Box
                    sx={{
                      bgcolor: "#E0F2FE",
                      borderRadius: "16px",
                      px: 1.2,
                      py: 1,
                      maxWidth: "85%",
                      ml: "auto",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      fontSize: "0.75rem",
                      lineHeight: 1.4,
                      position: "relative",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        right: -6,
                        top: 10,
                        width: 0,
                        height: 0,
                        borderTop: "6px solid transparent",
                        borderBottom: "6px solid transparent",
                        borderLeft: "6px solid #E0F2FE",
                      },
                    }}
                  >
                    {message?.trimEnd() ? (
                      message.trimEnd()
                    ) : (
                      <TypingIndicator />
                    )}
                  </Box>

                  <Divider sx={{ my: 1.5 }} />
                </Box>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Box>

      {/* ── Preview / Review Modal ──────────────────────────────────────── */}
      {isPreviewopen && (
        <Dialog
          open={isPreviewopen}
          onClose={() => setIsPreviewopen(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Review Your Campaign Details</DialogTitle>

          <DialogContent dividers>
            {!data || !reviewData ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 200,
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <>
                {data?.results && (
                  <Box mb={2}>
                    <Typography variant="h6" gutterBottom>
                      Processing Results
                    </Typography>

                    <Grid container spacing={1}>
                      {[
                        { label: "Total Posted", value: data.results.totalposted },
                        { label: "Total Remains", value: data.results.totalremains },
                        {
                          label: "Last Campaign Filter",
                          value: data.results.totalsevendaysfilter,
                        },
                        {
                          label: "Global Blacklist",
                          value: data.results.totalglobalblacklist,
                        },
                        {
                          label: "Customer Blacklist",
                          value: data.results.totalcustomerblacklist,
                        },
                        { label: "Duplicates", value: data.results.totalduplicates },
                        { label: "Estimated Cost", value: data.results.total_cost },
                      ].map(({ label, value }) => (
                        <Grid key={label} size={{ xs: 6, md: 2 }}>
                          <Paper
                            variant="outlined"
                            sx={{ p: 0.75, borderRadius: 1.5, textAlign: "center" }}
                          >
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              display="block"
                            >
                              {label}
                            </Typography>
                            <Typography variant="body2" fontWeight="bold">
                              {value ?? "-"}
                            </Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}

                <Box>
                  <Typography variant="h6" gutterBottom>
                    Campaign Details
                  </Typography>

                  <Grid container spacing={2}>
                    {[
                      { label: "Campaign", value: reviewData?.campaignname },
                      { label: "Entity", value: reviewData?.entity },
                      { label: "Sender ID", value: reviewData?.senderId },
                      {
                        label: "Message",
                        value: (
                          <Box sx={{ whiteSpace: "pre-wrap" }}>
                            {reviewData?.message}
                          </Box>
                        ),
                      },
                      { label: "No of Days", value: filterDatatill_days || "0" },
                      { label: "Landing Page", value: reviewData?.landingPage },
                      {
                        label: "Split Scheduler",
                        value: reviewData?.splitScheduler || "Disabled",
                      },
                      {
                        label: "Message Stats",
                        value: `${reviewData?.charCount} characters | ${reviewData?.smsCount} SMS`,
                      },
                    ].map(({ label, value }) => (
                      <Grid key={label} size={{ xs: 12, md: 4 }}>
                        <Paper variant="outlined" sx={{ p: 1, borderRadius: 2 }}>
                          <Typography variant="body2" color="text.secondary">
                            {label}
                          </Typography>
                          <Typography variant="subtitle2" fontWeight="bold">
                            {value ?? "-"}
                          </Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </>
            )}
          </DialogContent>

          <strong
            style={{
              color:
                data?.results?.is_campaign_ready === "yes" ? "green" : "red",
              textAlign: "center",
            }}
          >
            {data?.results?.message}
          </strong>

          <DialogActions>
            <Button onClick={() => setIsPreviewopen(false)}>Edit</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={
                data?.results?.is_campaign_ready !== "yes" ||
                Number(data?.results?.totalremains) === 0
              }
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* ── Template Modal ──────────────────────────────────────────────── */}
      {isTemplateModalOpen && (
        <Dialog
          open={isTemplateModalOpen}
          onClose={() => {
            setIsTemplateModalOpen(false);
            setTemplateSearch("");
          }}
        >
          <DialogTitle sx={{ fontSize: "0.75rem", fontWeight: "bold", pb: 0.5 }}>
            Select Template
          </DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              size="small"
              label="Search template by name"
              value={templateSearch}
              onChange={(e) => setTemplateSearch(e.target.value)}
              sx={{ mb: 1.5 }}
            />
            {templatesLoading ? (
              <CircularProgress />
            ) : templatesError ? (
              <Typography color="error">Error loading templates</Typography>
            ) : filteredTemplates.length > 0 ? (
              <List sx={{ backgroundColor: "#fff", p: 0 }}>
                {filteredTemplates.map((template) => (
                  <ListItem
                    button
                    key={template.template_id}
                    sx={{
                      mb: 1,
                      backgroundColor: "#fff",
                      border: "1px solid #e0e0e0",
                      borderRadius: 1,
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                    onClick={() => handleTemplateSelect(template)}
                  >
                    <ListItemText
                      primary={
                        <>
                          <span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>
                            Template Name: {template.template_name}
                          </span>
                          <br />
                          <span style={{ fontSize: "0.75rem" }}>
                            {template.template_text}
                          </span>
                        </>
                      }
                      secondary={
                        <>
                          <span style={{ fontSize: "0.7rem" }}>
                            ID: {maskNumber(template.trai_template_id)}
                          </span>
                          {template.header_id && (
                            <>
                              <br />
                              <span style={{ fontSize: "0.7rem", color: "#1976d2" }}>
                                Header:{" "}
                                {getHeaderName(template.header_id) || "Unknown"}
                              </span>
                            </>
                          )}
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography>
                {templateSearch
                  ? "No templates match your search"
                  : "No templates available"}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setIsTemplateModalOpen(false);
                setTemplateSearch("");
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* ── File from Database Modal ────────────────────────────────────── */}
      {isFileModalOpen && (
        <Dialog
          open={isFileModalOpen}
          onClose={() => setIsFileModalOpen(false)}
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              width: { xs: "95vw", sm: "60vw", md: "50vw" },
              maxHeight: "80vh",
            },
          }}
        >
          <DialogTitle sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>
            Select File From Database
          </DialogTitle>
          <DialogContent>
            {dbFilesLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress />
              </Box>
            ) : dbFiles?.data?.length > 0 ? (
              <Box sx={{ width: "100%" }}>
                <TableContainer>
                  <Table>
                    <TableHead
                      sx={{
                        bgcolor: "#0288d1",
                        "& th": {
                          color: "white",
                          fontSize: "0.75rem",
                          borderBottom: "0.5px solid #B0B0B0",
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell sx={{ width: "10px", borderRight: "0.5px solid #B0B0B0" }}>
                          Sr.No
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>Filter Name</TableCell>
                        <TableCell sx={{ textAlign: "center", borderRight: "0.5px solid #B0B0B0" }}>
                          File No
                        </TableCell>
                        <TableCell sx={{ textAlign: "center", borderRight: "0.5px solid #B0B0B0" }}>
                          Total Count
                        </TableCell>
                        <TableCell sx={{ textAlign: "center", borderRight: "0.5px solid #B0B0B0" }}>
                          Fields In File
                        </TableCell>
                        <TableCell sx={{ textAlign: "center", borderRight: "0.5px solid #B0B0B0" }}>
                          Created At
                        </TableCell>
                        <TableCell sx={{ width: "10px", borderRight: "0.5px solid #B0B0B0" }}>
                          Select
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dbFiles.data.map((file, index) => (
                        <TableRow key={file.path}>
                          <TableCell sx={{ padding: "8px", borderRight: "0.5px solid #B0B0B0" }}>
                            {index + 1}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "8px",
                              textAlign: "center",
                              borderRight: "0.5px solid #B0B0B0",
                            }}
                          >
                            {file.filter_name}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "8px",
                              textAlign: "center",
                              borderRight: "0.5px solid #B0B0B0",
                            }}
                          >
                            {file.page_no}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "8px",
                              textAlign: "center",
                              borderRight: "0.5px solid #B0B0B0",
                            }}
                          >
                            {file.totalcount}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "8px",
                              textAlign: "center",
                              borderRight: "0.5px solid #B0B0B0",
                            }}
                          >
                            {["", null, undefined, "NA"].includes(file.fieldsinfile)
                              ? "Mobile"
                              : file.fieldsinfile}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "8px",
                              textAlign: "center",
                              borderRight: "0.5px solid #B0B0B0",
                            }}
                          >
                            {dayjs(file.createdat).format("DD/MM/YYYY")}
                          </TableCell>
                          <TableCell sx={{ padding: "8px", borderRight: "0.5px solid #B0B0B0" }}>
                            <Radio
                              size="small"
                              checked={selectedDbFile?.path === file.path}
                              onChange={() => {
                                setSelectedDbFile(file);
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {selectedDbFile && (
                  <Box sx={{ mt: 2, textAlign: "right" }}>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={() => {
                        setFile(null);
                        setFileNames(`From DB: ${selectedDbFile.filter_name}`);
                        setFileSource("chooseDb");
                        setIsFileModalOpen(false);
                      }}
                    >
                      Submit
                    </Button>
                  </Box>
                )}
              </Box>
            ) : (
              <Typography>No files available in database</Typography>
            )}
          </DialogContent>
        </Dialog>
      )}

      {/* ── Country Modal ───────────────────────────────────────────────── */}
      {isCountryModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-sm w-full relative">
            <h2 className="text-xl font-semibold mb-4 text-[0.8rem]">
              Select Country
            </h2>
            <button
              type="button"
              onClick={() => setIsCountryModalOpen(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <div className="max-h-96 overflow-y-auto">
              {countriesData?.data?.length > 0 ? (
                countriesData.data.map((country) => (
                  <div
                    key={country.customer_country_id}
                    onClick={() => {
                      handleCountrySelect(
                        country.country_id,
                        country.country.country_name,
                        country.country.countrycode,
                      );
                    }}
                    className={`p-3 mb-2 cursor-pointer rounded hover:bg-gray-100 ${
                      selectedCountry?.id === country.country_id
                        ? "bg-blue-100"
                        : ""
                    }`}
                  >
                    {country.country.country_name} (
                    {country.country.countrycode.trim()})
                  </div>
                ))
              ) : (
                <p>No countries available</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateCampaign;